import React, { useCallback } from 'react';

import useOutsideClick from 'hooks/useOutsideClick';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { CurrencyCode } from 'models/currencyCode';
import { Container, Item, Items } from './styles';

interface Props {
  show: boolean;
  value: any;
  currencyCodes: CurrencyCode[];
  selectRef: React.RefObject<HTMLDivElement>;
  onChange: (value: CurrencyCode) => void;
  onClose: () => void;
}

interface MakeItemProps {
  className: string;
  text: string;
  onClick: (e: React.MouseEvent<HTMLLIElement>) => void;
}

const MakeItem = ({ text, ...rest }: MakeItemProps) => <Item {...rest}>{text}</Item>;

const SelectCurrency = ({ show, currencyCodes, selectRef, value, onChange, onClose }: Props) => {
  useOutsideClick(selectRef, onClose);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t } = useStoreTranslation();

  const isCurrencyActive = useCallback((item: CurrencyCode) => item === value, [value]);

  const handleItemClick = (reason: CurrencyCode) => {
    if (reason !== value) {
      onChange(reason);
    }
    onClose();
  };

  return show ? (
    <Container>
      <Items>
        {currencyCodes &&
          currencyCodes.map((c) => (
            <MakeItem
              key={c.value}
              className={isCurrencyActive(c) ? 'active' : ''}
              text={c.name}
              onClick={() => handleItemClick(c)}
            />
          ))}
      </Items>
    </Container>
  ) : null;
};

export default SelectCurrency;
